import { arrayOf, bool, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const projectRoleType = shape({
  id: string,
  roleId: string,
  regionId: string,
  functionalAreaId: string,
  limitedList: bool,
  isNotApplicable: bool,
  canSetNotApplicable: bool,
  isDeleted: bool,
  assignedUsers: arrayOf(string),
  availableUsers: arrayOf(string),
});
